import { render, staticRenderFns } from "./TextComponentForm.vue?vue&type=template&id=353c6c72&scoped=true&"
import script from "./TextComponentForm.vue?vue&type=script&lang=ts&"
export * from "./TextComponentForm.vue?vue&type=script&lang=ts&"
import style0 from "./TextComponentForm.vue?vue&type=style&index=0&id=353c6c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c6c72",
  null
  
)

export default component.exports